import React from "react";




const LeaderboardMain = () => {
 return(
    <div className="leaderboardContainer">
      
    </div>
 )
}

export default LeaderboardMain;